import React from "react";

// Components
import EHRProductSection from "../EHRProductSection";

// Static content
import { facilitatorContent, healingCenterContent } from "../../data/ehrContent";

const DynamicEHRSection = ({ userType, selectedProduct, setSelectedProduct, currentProducts, shouldUpdateParentState = true }) => {
  const isHealing = userType === "healingCenters";
  const currentContent = isHealing ? healingCenterContent : facilitatorContent;

  return (
    <>
      {/* Product Selection Section */}
      <EHRProductSection
        selectedProduct={selectedProduct}
        setSelectedProduct={setSelectedProduct}
        sortedPackages={currentProducts || []}
        userType={userType}
        shouldUpdateParentState={shouldUpdateParentState}
      />
    </>
  );
};

export default DynamicEHRSection;
